<!-- HARDIK KUMAR code start-->

<div class="row" id="AscRow">
  <div class="col-md-12" id="AscCol">
    <mat-card appearance="outlined" class="marB16" id="AscMatCard">
      <div *ngIf="editactivity">
        <button mat-icon-button class="close-button" [mat-dialog-close]="true" id="AscBtn">
          <mat-icon class="close-icon" color="warn" id="AscIcon">close</mat-icon>
        </button>
      </div>
      <div class="d-flex justify-content-between" style="margin-left: 18px; margin-top: 18px">
        <div class="txt_left" *ngIf="checkStatusChangeObj !== undefined">
          <h4 class="h3Header GreyDarkest text-1line marB16" id="AscActName">
            {{ checkStatusChangeObj.activityName }}
          </h4>
        </div>

        <div class="txt_left" *ngIf="coupledcheckStatusChangeObj !== undefined">
          <h4 class="h3Header GreyDarkest text-1line marB16">{{ coupledcheckStatusChangeObj.activityName }}</h4>
        </div>
        <div class="d-flex" style="margin-right: 18px">
          <span class="data-letters float-left marR6 listleft" id="AscUser">{{
            loginUserName || 'NA' | initials
          }}</span>
          <h5 class="marginicon40 h5Header GreyLight marT8 float-right marR16" id="AscLogin">{{ loginUserName }}</h5>
          <span class="marT4">
            <span
              class="marginicon40 mainBodyTxt3 GreyLight blockInfo"
              *ngIf="timeModifiedOn; else elseTemplate"
              id="AscDate"
            >
              {{ timeModifiedOn | dateTransform }}
            </span>
            <ng-template class="mainBodyTxt3 GreyLight blockInfo" #elseTemplate id="AscTemp"> </ng-template>
          </span>
        </div>
      </div>

      <mat-card-content
        class="clearfix"
        [ngStyle]="{ display: !isCollapsed ? 'none' : 'block' }"
        [ngClass]="{ readActivityDisable: data?.readFlag }"
      >
        <div *ngIf="checkStatusChangeObj.activityId != 500317">
          <form name="statuschangeForm" #f="ngForm">
            <div *ngIf="this.testformValid(!f.invalid)"></div>
            <div
              class="mutil-selector-wrap"
              [ngStyle]="{ justifyContent: isInterviewDateRequired ? 'left' : 'space-between' }"
              *ngIf="checkStatusChangeObj !== undefined"
            >
              <div class="marR16">
                <mat-form-field class="custom-form-field" *ngIf="checkStatusChangeObj.activityId != 500312">
                  <mat-label>Reason </mat-label>
                  <mat-select [(ngModel)]="reasonId" name="reasonId" required [value]="reasonId">
                    <!-- since rejectionReasons is not array ; pls fix; removing as of now creating prod errors -->

                                        <ng-container *ngFor="let reason of rejectionReasons; let i = index;">
                                            <mat-option [value]="reason[0]"
                                                (click)="reasonIdChange(reason)" [disabled]="companyHiringType == 1 && noOfTimes>=0 && i !== noOfTimes"
                                                *ngIf="isReasonHidden(reason)">
                                                {{reason[1]}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                        </div>
                        <mat-form-field *ngIf="isInterviewDateRequired">
                            <mat-label>Interview Date </mat-label>
                            <input matInput required [matDatepicker]="picker" name="unavailableDate" [(ngModel)]="unavailableDate"
                            [min]="minDate" >
                            <mat-icon matSuffix>
                                <img src="assets/images/icons/purple_icons/icon-calendar.png" alt="icon-calendar" (click)="picker.open()">
                            </mat-icon>
                            <mat-datepicker #picker touchUi></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <mat-card appearance="outlined" class="narrow-card" *ngIf="checkStatusChangeObj.activityId == 500312">
                        <mat-card-content>
                            <h6 style="display: inline-block;">Status:</h6>
                            <span style="display: inline-block; margin-left: 5px;">{{ bcgStatus }}</span>
                        </mat-card-content>
                    </mat-card>
                    <br>
                    <mat-form-field class="custom-form-field"
                        *ngIf="checkStatusChangeObj !==undefined && !recallActivity && remarksMandatory && checkStatusChangeObj.activityId != 500312">
                        <!-- <input matInput placeholder="Remarks" name="notes" [(ngModel)]="notes" (input)="selectedValue = $event.target.value"> -->
                        <mat-label>Remarks</mat-label>
                        <textarea matInput rows="5" name="notes" [(ngModel)]="notes"
                            (input)="selectedValue = $event.target.value" appNoWhiteSpc
                            [required]="checkStatusChangeObj.activityId == 200304 || checkStatusChangeObj.activityId == 500305">
                        </textarea>
                    </mat-form-field>
                        <div *ngIf="checkStatusChangeObj.activityId == 600311 && companyHiringType == 4 && veriFace()">
                            <mat-card appearance="outlined" class="marB16" *ngIf="getResultEntries().length > 0">
                                <mat-card-content>
                                    <h6 style="margin-bottom: 12px;"><strong>Face Validation Results:</strong></h6>

                  <table aria-describedby="faceValidationResultsCaption" style="width: 100%; border-collapse: collapse">
                    <thead>
                      <tr style="background-color: #f8f9fa; border-bottom: 2px solid #dee2e6">
                        <th style="padding: 8px; text-align: left; width: 40%">Comparison</th>
                        <th style="padding: 8px; text-align: center; width: 30%">Status</th>
                        <th style="padding: 8px; text-align: right; width: 30%">Confidence</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let result of getResultEntries()" style="border-bottom: 1px solid #dee2e6">
                        <td style="padding: 8px">
                          <strong>{{ result[0] }}</strong>
                        </td>
                        <td style="padding: 8px; text-align: center">
                          <span
                            [style.color]="result[1]?.status === 'Pass' ? '#28a745' : '#dc3545'"
                            [style.font-weight]="'600'"
                            [style.padding]="'4px 12px'"
                            [style.border-radius]="'4px'"
                            [style.display]="'inline-block'"
                            [style.background-color]="result[1]?.status === 'Pass' ? '#d4edda' : '#f8d7da'"
                          >
                            {{ result[1]?.status }}
                          </span>
                        </td>
                        <td style="padding: 8px; text-align: right; color: #6c757d">
                          {{ result[1].confidence }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div style="color: red; font-size: 11px; margin-top: 5px">
                    <b>Note:</b> AI outputs assist verification and require human final decision-making.
                  </div>
                </mat-card-content>
              </mat-card>
              <div style="display: grid; grid-template-columns: 1fr 2fr; gap: 16px">
                <mat-form-field class="custom-form-field">
                  <mat-label>Final Status</mat-label>
                  <input matInput [value]="faceValidationData()?.status" name="faceValidationStatus" readonly />
                  <mat-icon
                    matSuffix
                    [style.color]="faceValidationData()?.status === 'Success' ? '#28a745' : '#dc3545'"
                  >
                    {{ faceValidationData()?.status === 'Success' ? 'check_circle' : 'cancel' }}
                  </mat-icon>
                </mat-form-field>

                <mat-form-field class="custom-form-field">
                  <mat-label>Message</mat-label>
                  <input matInput [value]="faceValidationData()?.message" name="faceValidationMsg" readonly />
                </mat-form-field>
              </div>
            </div>

            <mat-form-field
              class="custom-form-field"
              *ngIf="checkStatusChangeObj !== undefined && recallActivity && remarksMandatory"
            >
              <mat-label>Remarks*</mat-label>
              <textarea
                matInput
                rows="5"
                name="notes"
                [(ngModel)]="notes"
                (input)="selectedValue = $event.target.value"
                required
              ></textarea>
            </mat-form-field>
            <mat-form-field class="custom-form-field" *ngIf="!remarksMandatory">
              <mat-label>Remark</mat-label>
              <textarea
                matInput
                rows="5"
                name="notes"
                [(ngModel)]="notes"
                (input)="selectedValue = $event.target.value"
                required
              ></textarea>
            </mat-form-field>
            <mat-card appearance="outlined" *ngIf="checkStatusChangeObj !== undefined">
              <app-attachment
                name="recalloffer"
                (fileOutput)="receiveFileOutput($event)"
                [enableToggle]="offerRejectCheck || offerInvalidRejectCheck"
                [offerRejectCheck]="offerRejectCheck"
                [offerInvalidRejectCheck]="offerInvalidRejectCheck"
                [toggleBtn]="toggleBtn"
                [allowedTypes]="allowedTypes"
                [uploadType]="multiple"
                [editId]="editId"
                activityModuleFlag="true"
                [isMapFile]="isMapFile"
              ></app-attachment>
            </mat-card>

            <div class="row" *ngIf="!ifCoupled">
              <div class="col-md-2">
                <div class="row nomarLR padTB16">
                  <button
                    mat-raised-button
                    class="primary-btn btnfullWdth"
                    [disabled]="f.invalid || disableSFO || enableSendButton() || disableOfferSendBtn"
                    id="recallrevokesend"
                    (click)="send()"
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="checkStatusChangeObj.activityId == 500317" class="padT16">
          <ng-container *ngIf="hrChecklist">
            <div *ngFor="let hrc of hrChecklist; let si = index">
              <mat-accordion class="accordion">
                <mat-expansion-panel
                  [expanded]="expandedEvent === hrc.sectionName && si == selectedIndexQ"
                  (opened)="expandedEvent = hrc.sectionName; selectedIndexQ = si"
                >
                  <mat-expansion-panel-header class="customExpansionPanel">
                    <strong> {{ hrc.sectionName }} </strong>
                  </mat-expansion-panel-header>
                  <br />
                  <form name="hrChecklist" #f="ngForm" class="marL16">
                    <div *ngFor="let hrcQues of hrc.question; let qi = index" class="marB8">
                      {{ qi + 1 }}.{{ hrcQues.questionDesc }}
                      <br />
                      <mat-radio-group aria-label="Select an option" id="hrc-{{ si }}{{ qi }}">
                        <span *ngFor="let hrcqOption of hrcQues.options; let index = index">
                          <mat-radio-button
                            [value]="hrcqOption"
                            [checked]="hrcqOption == hrcQues.selectedAns"
                            (change)="setHRans(si, qi, $event)"
                            style="padding-right: 16px"
                          >
                            {{ hrcqOption }}
                          </mat-radio-button>
                        </span>
                      </mat-radio-group>
                    </div>
                  </form>
                </mat-expansion-panel>
              </mat-accordion>
              <br />
            </div>
            <br />
            <br />
            <div style="display: block; margin-bottom: 16px">
              <mat-form-field class="custom-form-field" style="width: 250px">
                <mat-label>Offer Type</mat-label>
                <mat-select
                  [ngModel]="selectedOfferType()"
                  (ngModelChange)="selectedOfferType.set($event)"
                  name="selectedOfferType"
                  required
                >
                  <mat-option *ngFor="let offerType of allOfferTypes()" [value]="offerType.offerTypeCategory">
                    {{ offerType.offerTypeCategory }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <ng-container *ngIf="hrChecklist">
              <div style="display: block; margin-bottom: 8px">
                <mat-checkbox [(ngModel)]="hrApplicationForm" style="font-size: 15px" id="hrapplicationform">
                  <span style="cursor: text">
                    I'm confirming that I have validated all details in
                    <a href="javascript:void();" (click)="openViewProfile()">View profile</a> page and done the required
                    corrections.
                  </span>
                </mat-checkbox>
              </div>
              <div style="display: block; margin-bottom: 8px">
                <mat-checkbox [(ngModel)]="hrExpEHC" style="font-size: 15px" id="hrExpEHC">
                  <span style="cursor: text">
                    I have updated the experience(s) considered/not considered for the candidate in
                    <a href="javascript:void();" (click)="openViewProfile()">View profile</a> page,
                    <br />
                    so that work experience(s) can be considered accordingly for UAN verification.
                  </span>
                </mat-checkbox>
              </div>
              <mat-form-field class="custom-form-field">
                <label for="textarea"
                  ><strong>Remarks:</strong> *Update all the details that are edited in View profile page including work
                  experience considered/not considered.</label
                >
                <textarea
                  matInput
                  rows="5"
                  name="notes"
                  appNoWhiteSpc
                  [(ngModel)]="hrChecklistNotes"
                  (input)="hrChecklistNotes = $event.target.value"
                  required
                ></textarea>
              </mat-form-field>
            </ng-container>
          </ng-container>

          <mat-card *ngIf="checkStatusChangeObj !== undefined">
            <app-attachment
              name="actvtyAttach"
              (fileOutput)="receiveFileOutput($event)"
              [toggleBtn]="toggleBtn"
              [allowedTypes]="allowedTypes"
              [uploadType]="multiple"
              [editId]="editId"
              activityModuleFlag="true"
              [isMapFile]="isMapFile"
            ></app-attachment>
          </mat-card>

          <div class="row">
            <div class="col-md-2">
              <div class="row nomarLR padTB16">
                <button
                  mat-raised-button
                  class="primary-btn btnfullWdth"
                  id="hrsendbtn"
                  [disabled]="disableSubmit || !selectedOfferType()"
                  (click)="saveHRChecklist()"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions class="collapseAction">
        <div>
          <a
            href="javascript:void(0)"
            [ngClass]="isCollapsed ? 'icon x-24 up-arw-icon' : 'icon x-24 down-arw-icon'"
            (click)="showMoreLess()"
          ></a>
        </div>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
<ng-template #sfoContent let-c="close" let-d="dismiss">
  <div class="modal-dialogue propose_letter" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialogue propose_letter" data-backdrop="static" data-keyboard="false">
      <button type="button" id="close_button_letter" aria-label="Close" style="float: right" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-header">
        <h5 class="modal-title" id="modal-basic-title-offer-letter">Warning!</h5>
      </div>
    </div>
    <div class="modal-body wrapper col-md-12 pagesRef">
      <div class="row" style="padding-left: 30px; padding-right: 30px; padding-bottom: 15px; white-space: pre-line">
        {{ sfoMssg }}
      </div>
    </div>
  </div>
</ng-template>

<!-- HARDIK KUMAR code ends -->
